import { postApiGalaxyServer } from 'services';
import { AxiosResponse } from 'axios';
import ApiClientManager from 'core/apiClient';

export interface ProvisionReplicaDatabaseParams {
  tenant?: string;
  realmId?: string;
  teamId: number;
  targetServiceId: number;
  service: string;
  teamName: string;
}

export interface ProvisionReplicaDatabaseResponse {
  databaseName: string;
  replicationUser: string;
  status: string;
}

/**
 * Provisions a replica database in Azure for a given team and service.
 */
export const provisionReplicaDatabaseApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<ProvisionReplicaDatabaseParams>): Promise<
  AxiosResponse<ProvisionReplicaDatabaseResponse>
> => {
  const { tenant, realmId, ...body } = params;

  const customHeaders =
    tenant && realmId
      ? ApiClientManager.buildUrlHeaders({
          tenantName: tenant,
          realmId,
        })
      : undefined;

  return postApiGalaxyServer<
    Omit<ProvisionReplicaDatabaseParams, 'tenant' | 'realmId'>,
    ProvisionReplicaDatabaseResponse
  >(
    `/azure/provisionReplicaDatabase`,
    body,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
